import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import StatusHistory from './StatusHistory';
import { ajaxUpdateFeedbackStatus, updateModalContent, ajaxArchiveFeedback, ajaxBlockUser, reviewLinkSent, getRequestedVia, findWithAttr, ajaxFeedbackFilter } from '../redux/FeedbackRedux';


class StatusSection extends React.Component {
	constructor(props) {
		super(props);
		this.handleStatusClick = this.handleStatusClick.bind(this);
		this.handleArchiveClick = this.handleArchiveClick.bind(this);
		this.handleBlockClick = this.handleBlockClick.bind(this);
	}

	handleStatusClick(event){
		event.preventDefault();
		var status = jQuery(event.target).attr('id');
		var hide_chat_modal = false;
		var hide_notes_modal = false;
		var hide_review_modal = false;
		console.log("click");

		if(this.props.feedback.custom_qr_code){
			console.log("custom_qr_code");
			hide_chat_modal = this.props.feedback.custom_qr_code.hide_chat_modal;
			hide_notes_modal = this.props.feedback.custom_qr_code.hide_notes_modal;
			hide_review_modal = this.props.feedback.custom_qr_code.hide_review_modal;
		}

		if(this.props.feedback.otf_id){
			hide_review_modal = truel
		}

		if(status != this.props.state.feedback_detail.status){
			var id = this.props.feedback.feedback_id;
			if (status === window.feedbackStatus.Open.value) {
				this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
			} else if(status === window.feedbackStatus.Resolved.value) {
				if(this.props.feedback.chats.length == 0 && this.props.feedback.is_text == 1 && !hide_chat_modal) {
					var modal_id = "statusModal";
					var modal_title = __("Update Status");
					var modal_body =  __('You are marking a Feedback as \'Resolved\' where a chat/text response has been requested but no chat has been initiated by an employee. If the issue has been resolved, please consider sending them a chat to let them know, or consider adding notes to the system detailing how the feedback was resolved.') ;
					var button_1_class = "primary";
					var button_1_id = "cancel";
					var button_1_text = __('Cancel - I\'ll send them a chat') ;
					var button_2_class = "outline-secondary";
					var button_2_id = "setResolved";
					var button_2_text =  __("Continue without sending a chat") ;
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				} else if(this.props.feedback.chats.length == 0 && !this.props.feedback.is_text && this.props.feedback.notes.length == 0 && !hide_notes_modal) {
					var modal_id = "statusModal";
					var modal_title = "Update Status";
					var modal_body =  __('You are marking a Feedback as "Resolved" without any including any details about why it is being closed out. We encourage you to add notes to the Feedback detailing how it was resolved.');
					var button_1_class = "primary modal-add-notes-button";
					var button_1_id = "cancel";
					var button_1_text = "Cancel - I'll add notes";
					var button_2_class = "outline-secondary";
					var button_2_id = "setResolved";
					var button_2_text =  __("Continue without adding notes");
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				} else if (reviewLinkSent(this.props.feedback.chats) == false && this.props.feedback.is_text == 1 && !hide_review_modal) {
					var modal_id = "statusModal";
					var modal_title =  __("Update Status");
					var modal_body =  __("You are marking a Feedback as 'Resolved' where a Review Request link has not yet been sent to the Feedbacker in chat. If the issue has been resolved, please consider sending them the Review Request link in chat. ");
					var button_1_class = "primary";
					var button_1_id = "cancel";
					var button_1_text =  __("Cancel - I'll send them a review request link");
					var button_2_class = "outline-secondary";
					var button_2_id = "setResolved";
					var button_2_text =  __("Continue without sending the link");
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				} else {
					this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
				}
			} else if(status === window.feedbackStatus.Pending.value) {
				console.log("pending");
				var index = findWithAttr(this.props.state.feedback_detail.pendingreminders, "hashed_user_id", this.props.state.current_user);
				if(index !== false) {
					this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
				} else {
					var modal_id = "pendingModal";
					var modal_title =  __("Update Status");
					var modal_body = "pendingModal"
					var button_1_class = "outline-secondary";
					var button_1_id = "cancel";
					var button_1_text =  __("Cancel");
					var button_2_class = "outline-secondary";
					var button_2_id = "setPending";
					var button_2_text =  __("Continue without setting a reminder");
					this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
					jQuery('.modal:not(.error)').modal();
				}
			}
		}
	}

	handleArchiveClick(event){
		if(this.props.feedback.is_archived == 1) {
			event.preventDefault();
			this.props.dispatch(ajaxArchiveFeedback(this.props.feedback.feedback_id));
		} else {
			event.preventDefault();
			var modal_id = "archiveModal";
			var modal_title =  __("Archive Feedback");
			var modal_body =  __('Archiving this feedback will remove it from Feedback History and place it in "Feedback Archive" where it will be inaccessible to employees without manager privileges, and by default will not show up in reporting (unless specified)') ;
			var button_1_class = "outline-secondary";
			var button_1_id = "cancel";
			var button_1_text =  __("Cancel") ;
			var button_2_class = "danger";
			var button_2_id = "archive";
			var button_2_text =  __("Archive") ;
			this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
			jQuery('.modal:not(.error)').modal();
		}
    }

    handleBlockClick(event){
        event.preventDefault();
		this.props.dispatch(ajaxBlockUser(this.props.feedback.business_id, this.props.feedback.feedback_id));
    }

	render () {
		// var archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-outline-danger d-inline-block archive-button text-capitalize"><i className="fas fa-archive mr-1"></i> Archive</a>;
		// if (this.props.feedback.is_archived) {
		// 	archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-warning d-inline-block archive-button text-capitalize"><i className="fas fa-archive mr-1"></i> Unarchive</a>;
        // }
        // var index = findWithAttr(this.props.state.feedback_detail.user.blocks, "business_id", this.props.state.feedback_detail.business.business_id);
		// var block_button = "";
		// if (index !== false) {
		// 	block_button = <a href="#" onClick={this.handleBlockClick} className="btn btn-sm btn-warning d-inline-block archive-button text-capitalize ml-2"><i className="fas fa-user-times mr-1"></i> Unblock</a>;
		// } else {
        //     block_button = <a href="#" onClick={this.handleBlockClick} className="btn btn-sm btn-outline-danger d-inline-block archive-button text-capitalize ml-2"><i className="fas fa-user-times mr-1"></i> Block User</a>;
        // }
		return (
			<div className="card-body border-top pb-4 pt-4">

				<div className="row status align-items-center">
					<div className="col-sm-8">
						<h5 className="pb-0 mb-0 text-default"><span className="d-none d-sm-inline">{ __('Feedback') }</span> { __('Status') }:
						{ this.props.current_user &&
							<div className="dropdown d-inline mr-1">
								<button className="btn btn-card dropdown-toggle text-primary pb-0 pt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {window.feedbackStatus[this.props.feedback.status].label}
								</button>
								<div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
									<a className="dropdown-item" id={window.feedbackStatus.Open.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Open.label}</a>
									<a className="dropdown-item" id={window.feedbackStatus.Pending.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Pending.label}</a>
									<a className="dropdown-item" id={window.feedbackStatus.Resolved.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Resolved.label}</a>
                                    {this.props.state.businessHasAutoPilot && <a className="dropdown-item" id={window.feedbackStatus.RatingsOnly.value} onClick={this.handleStatusClick} href="#">{window.feedbackStatus.RatingsOnly.label}</a>}
								</div>
								<a href="#" className="btn btn-sm btn-outline-primary ml-1 view-history"><i className="fas fa-history mr-1"></i> { __('View Status History') }</a>
							</div>
						}
						{!this.props.current_user &&
							" " + window.feedbackStatus[this.props.feedback.status].label
						}
						</h5>
					</div>
					{ this.props.current_user &&
						<div className="col-sm-4 text-sm-right">
							{/* archive_button */} {/* block_button */}
						</div>
					}
					<StatusHistory />
				</div>
			</div>
		 );
	}
}

function mapStateToProps(state) {
	return { alert:state.alert.alert, state:state }
}
export default connect(mapStateToProps)(StatusSection)
